// extracted by mini-css-extract-plugin
export default {"photo":"Photo_photo__6ZeKO","rotatePhoto":"Photo_rotatePhoto__swCFk","imageFigure":"Photo_imageFigure__Ksnoe","text":"Photo_text__D1Ecr"};